import SuppliesRates from "./SuppliesRates";
export default SuppliesRates;
